<template>
  <ranch-button
    @click="showNewProjectModal"
    icon="plus-circle"
    :label="label"
  />
</template>

<script>
import NewProjectModal from "../Projects/NewProject/Modal";
import NewProjectModalConfig from "../Modals/configs/newproject";

export default {
  props: ["label"],
  data: function () {
    return {};
  },
  methods: {
    showNewProjectModal() {
      this.$modal.show(
        NewProjectModal,
        {
          step: 1,
        },
        NewProjectModalConfig
      );
    },
  },
  computed: {},
  mounted() {},
};
</script>
